import React, { useState, useEffect } from 'react'
import cx from 'classnames'

import { analyticsService } from 'utils/services/analytics'

import { MainScreen } from './MainScreen'
import { Survey } from './Survey'
import { useShouldShowMobileBanner } from './useShouldShowMobileBanner'

import cm from './MobileBanner.module.css'

export const MobileBanner = () => {
  const [isSurveyStarted, setIsSurveyStarted] = useState(false)
  const { closeBanner, shouldShowBanner } = useShouldShowMobileBanner()

  const handleCloseIconClick = () => {
    analyticsService.sendEvent('MOBILE_BANNER.SURVEY.CLOSE_ICON_CLICK')

    setIsSurveyStarted(true)
  }

  useEffect(() => {
    if (shouldShowBanner) {
      analyticsService.sendEvent('MOBILE_BANNER_SHOW')
    }
  }, [shouldShowBanner])

  if (!shouldShowBanner) return null

  return (
    <div className={cx(cm.banner, 'text-center')}>
      <div className={cx(cm.bannerContainer)}>
        {isSurveyStarted ? (
          <Survey closeBanner={closeBanner} />
        ) : (
          <MainScreen onClose={handleCloseIconClick} />
        )}
      </div>
    </div>
  )
}

export default MobileBanner
